module.exports = __webpack_public_path__ + "img/fns-420x600.bd368ede.jpg";